import React from 'react';

import Login from '../pages/login';

import Admins from '../pages/admins';
import Categories from '../pages/categories';
import MasterCategories from '../pages/masterCategories';
import CatProd from '../pages/catprod';
import CategoriesList from '../pages/catcatprod';
import Deliverers from '../pages/deliverer';
import DelivTypes from '../pages/delivTypes';
import Globals from '../pages/globals';
import Payments from '../pages/payments';
// import Products from '../pages/products';
import CategoryProds from '../pages/categoryprods';
import Regions from '../pages/regions';
import Sellers from '../pages/sellers';
import Orders from '../pages/orders';
import OrderCounts from '../pages/orderCounts';
import Users from '../pages/users';
import Bindings from '../pages/bindings';
import Banners from '../pages/banners';
import Settings from '../pages/settings';
import { Router, Redirect, Switch } from 'react-router-dom';
import { history } from '../config/globals';
import AuthRoute from './auth';
import UnauthRoute from './unauth';
import { Container, Spinner, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import Header from '../components/header';

const headerLinks = [
	{ name: 'Globals', link: '/globals' },
	{ name: 'App Settings', link: '/settings' },
	{ name: 'Banners', link: '/banners' },
	{ name: 'Admins', link: '/admins' },
	{ name: 'Regions', link: '/regions' },
	// {name: 'Sellers', link: '/sellers'},
	{ name: 'Deliverer Types', link: '/types' },
	{ name: 'Master Categories', link: '/master-categories' },
	{ name: 'Categories', link: '/categories' },
	{ name: 'Products', link: '/products' },
	{ name: 'Orders', link: '/orders' },
	{ name: 'Order Counts', link: '/ordercount' },
	{ name: 'Payments', link: '/payments' },
	{ name: 'Users', link: '/users' },
	{ name: 'Seller Groups', link: '/bindings' },
];

class AppRoutes extends React.Component {
	render() {
		const { userid, loading } = this.props;
		return (
			<Container fluid={true}>
				<Modal show={loading} centered size="sm">
					<Modal.Dialog style={{ backgroundColor: 'transparent', border: 'none' }}>
						<Spinner animation="border" />
					</Modal.Dialog>
				</Modal>
				<Router history={history}>
					{userid ?
						<Header
							links={headerLinks}
						/>
						:
						<></>
					}
					<Switch>
						<Redirect exact from="/" to="/login" />

						<UnauthRoute loggedIn={Boolean(userid)} exact path="/login" component={Login} />

						<AuthRoute loggedIn={Boolean(userid)} exact path="/admins" component={Admins} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/types" component={DelivTypes} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/categories" component={Categories} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/master-categories" component={MasterCategories} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/catprod/:id" component={CatProd} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/sub-categories/:id" component={CategoriesList} />
						{/* <AuthRoute loggedIn={Boolean(userid)} exact path="/categories" component={CategoryProds} /> */}
						<AuthRoute loggedIn={Boolean(userid)} exact path="/deliverer/:id" component={Deliverers} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/globals" component={Globals} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/settings" component={Settings} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/payments" component={Payments} />
						{/* <AuthRoute loggedIn={Boolean(userid)} exact path="/products" component={Products} /> */}
						<AuthRoute loggedIn={Boolean(userid)} exact path="/products" component={CategoryProds} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/regions" component={Regions} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/sellers/:id" component={Sellers} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/orders" component={Orders} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/ordercount" component={OrderCounts} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/users" component={Users} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/bindings" component={Bindings} />
						<AuthRoute loggedIn={Boolean(userid)} exact path="/banners" component={Banners} />

						<Redirect from="*" to="/login" />
					</Switch>
				</Router>
			</Container>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: state.common.loading,
	userid: state.session.userid
});

export default connect(mapStateToProps)(AppRoutes);